module.exports = __webpack_public_path__ + "img/manet_5.45522d1f.jpg";